import { truncateText } from "@/lib/utils";
import "./CardGeneral.css";
import Image from "next/image";
import Link from "next/link";
import Icon from "@/components/client/Icon";

export interface CardGeneral {
  image?: {
    url: string;
    alt: string;
    width: number;
    height: number;
  };
  images?: [
    {
      browserWidth: string;
      url: string;
      alt: string;
      height: number;
      width: number;
    },
  ];
  imageType?: "asImage" | "asBackground";
  eyebrow?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  slug: string;
  truncate?: boolean;
  truncateLength?: number;
}

export const CardGeneral = ({
  image,
  images,
  imageType,
  eyebrow,
  title,
  description,
  buttonLabel,
  slug,
  truncate,
  truncateLength,
}: CardGeneral) => {
  let cardImageClasses = `t2-card--general__image`;
  // console.log(image);
  /* if the card image is being rendered as an <img> then it's more complicated */
  let imageFound = null;
  if (imageType == "asImage") {
    cardImageClasses = `${cardImageClasses} small`;
    imageFound = images?.find((obj) => obj["browserWidth"] === "small");
  }
  return (
    <div
      className={`t2-card t2-card--general t2-card--general--bound t2-color-setting--light flex flex-col h-full`}
    >
      {imageType !== "asImage" && image?.url && (
        <div
          className={cardImageClasses}
          style={{ backgroundImage: `url(${image?.url})` || "" }}
        >
          {image?.alt}
        </div>
      )}
      {imageType == "asImage" && image?.url && (
        <Image
          className={cardImageClasses}
          src={imageFound?.url || image.url}
          alt={imageFound?.alt || image.alt || title || ""}
          quality={80}
          width={imageFound?.width || image.width}
          height={imageFound?.height || image.height}
        />
      )}
      {/* <p className="text-xs">Card Tags: {cardTags?.map((tag: any) => { return `${tag?.title}, ` })}</p> */}
      <div className="t2-card--general__content">
        {eyebrow && <div className="t2-card--general__eyebrow">{eyebrow}</div>}
        {title && <h3 className="t2-card--general__header">{title}</h3>}
        {description && truncate && (
          <p className="t2-card--general__description">
            {truncateText(description, truncateLength)}
          </p>
        )}
      </div>
      {slug && (
        <Link href={slug} className="t2-terra-text-link ">
          {buttonLabel}{" "}
          <Icon
            label="View Post"
            type={"t2u-chevron-right"}
            size={20}
            className="ml-2"
          />
        </Link>
      )}
    </div>
  );
};
